import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { useNavigate } from 'react-router-dom';
export function ModifyProfile() {
  const navigate = useNavigate();
  const enrolledCourses = [{
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/23/2012'
  }, {
    name: "Don't Lose Your License",
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'The Owner Is In Default',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'They Are A Protected Class',
    status: '(Course enrolled)',
    creditType: '3 hrs. Fair Housing',
    created: '04/11/2012'
  }, {
    name: 'A Letter From ADRE',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'Are They Represented?',
    status: '(Section in progress)',
    creditType: '3 hrs. Agency Law',
    created: '04/11/2012'
  }, {
    name: 'Follow All The Laws',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'No Secrets',
    status: '(Course enrolled)',
    creditType: '3 hrs. Disclosure',
    created: '04/11/2012'
  }, {
    name: 'Common Contract Issues',
    status: '(Section in progress)',
    creditType: '3 hrs. Contract Law',
    created: '04/11/2012'
  }];
  return <div className="space-y-6" data-id="element-1277">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1278">Manage Profile</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1279">
        {/* Left Column: Profile Fields */}
        <Card data-id="element-1280">
          <CardHeader data-id="element-1281">
            <CardTitle data-id="element-1282">Profile Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-1283">
            <Input label="Title" defaultValue="Mr" data-id="element-1284" />
            <Input label="First Name" defaultValue="Admin" data-id="element-1285" />
            <Input label="Last Name" defaultValue="Admin" data-id="element-1286" />
            <Input label="Company" defaultValue="Desert Sage Seminars" data-id="element-1287" />
            <Input label="Address 1" defaultValue="15560 N. Frank Lloyd W" data-id="element-1288" />
            <Input label="Address 2" defaultValue="#B4-5185" data-id="element-1289" />
            <Input label="City" defaultValue="Scottsdale" data-id="element-1290" />
            <Select label="State/Province *" defaultValue="AZ" options={[{
            value: 'AZ',
            label: 'Arizona'
          }, {
            value: 'CA',
            label: 'California'
          }, {
            value: 'NV',
            label: 'Nevada'
          }]} data-id="element-1291" />
            <Input label="Zip" defaultValue="85260" data-id="element-1292" />
            <Input label="Phone" defaultValue="602-377-6207" data-id="element-1293" />
            <Input label="Email" helperText="Leave blank to keep existing email (administration@desertsageseminars.com)" data-id="element-1294" />
            <Input label="Fax" data-id="element-1295" />
            <Input label="How Did You Hear About Us" data-id="element-1296" />
            <Input label="Facebook" data-id="element-1297" />
            <Input label="Username" helperText="Leave blank to keep existing username (admin)" data-id="element-1298" />
            <Input type="password" label="Password" helperText="Leave blank to keep existing password" data-id="element-1299" />

            <div className="py-2" data-id="element-1300">
              <a href="#" className="text-blue-600 hover:underline text-sm" data-id="element-1301">
                Click here to obtain your license expiration date from ADRE
              </a>
            </div>

            <Input label="Available Courses" defaultValue="0" data-id="element-1302" />

            <div className="pt-4" data-id="element-1303">
              <Button data-id="element-1304">Update</Button>
            </div>
          </CardContent>
        </Card>

        {/* Right Column: Course Assignments */}
        <div className="space-y-6" data-id="element-1305">
          <Card data-id="element-1306">
            <CardContent className="space-y-4 pt-6" data-id="element-1307">
              <Select label="Course" options={[{
              value: '1',
              label: 'NAR Code of Ethics (NO CE CREDIT)'
            }, {
              value: '2',
              label: 'Ethics & The Rules (with NAR Code of Ethics)'
            }, {
              value: '3',
              label: 'Deeds, Fires & Water: Be Prepared'
            }, {
              value: '4',
              label: 'Are They Represented?'
            }, {
              value: '5',
              label: 'Mastering Agency Agreements'
            }, {
              value: '6',
              label: 'A Letter From ADRE'
            }, {
              value: '7',
              label: "Don't Lose Your License"
            }, {
              value: '8',
              label: 'BMC #1 AZ Residential-Statutes and Rules'
            }, {
              value: '9',
              label: 'BMC #2 AZ Residential-Broker Policies'
            }, {
              value: '10',
              label: 'BMC #3 AZ Residential-Broker Supervision'
            }, {
              value: '11',
              label: 'BMC #3B Property Management'
            }, {
              value: '12',
              label: 'What Goes Wrong In Contracts'
            }, {
              value: '13',
              label: 'Avoid The Oops: Contract Smarts for Agents'
            }, {
              value: '14',
              label: 'No Secrets'
            }, {
              value: '15',
              label: 'The Bottom Line of Disclosure'
            }, {
              value: '16',
              label: 'Your Clients Are Not Mushrooms'
            }, {
              value: '17',
              label: 'They Are A Protected Class'
            }, {
              value: '18',
              label: "Fair Housing In Today's World"
            }, {
              value: '19',
              label: 'Accidental Property Management'
            }, {
              value: '20',
              label: 'Follow All The Laws'
            }]} data-id="element-1308" />
              <Select label="Statuses" defaultValue="enrolled" options={[{
              value: 'completed',
              label: 'Course Completed'
            }, {
              value: 'in_progress',
              label: 'Course in Progress'
            }, {
              value: 'emailed',
              label: 'Certificate Emailed'
            }, {
              value: 'enrolled',
              label: 'Course Enrolled'
            }, {
              value: 'section_progress',
              label: 'Section in Progress'
            }]} data-id="element-1309" />
              <Button className="w-full gap-2" data-id="element-1310">
                <Plus className="h-4 w-4" data-id="element-1311" />
                Add
              </Button>
            </CardContent>
          </Card>

          <Card data-id="element-1312">
            <CardHeader data-id="element-1313">
              <CardTitle data-id="element-1314">Enrolled Courses</CardTitle>
            </CardHeader>
            <div className="overflow-x-auto" data-id="element-1315">
              <table className="w-full text-sm text-left" data-id="element-1316">
                <thead className="bg-slate-800 text-white font-medium border-b border-slate-700" data-id="element-1317">
                  <tr data-id="element-1318">
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1319">
                      Course Name
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1320">
                      Credit Type
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-1321">
                      Created
                    </th>
                    <th className="px-4 py-3" data-id="element-1322">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-1323">
                  {enrolledCourses.map((course, index) => <tr key={index} className="hover:bg-slate-50" data-id="element-1324">
                      <td className="px-4 py-3 border-r border-slate-200" data-id="element-1325">
                        <div className="text-slate-900" data-id="element-1326">{course.name}</div>
                        <div className="text-slate-500 text-xs mt-0.5" data-id="element-1327">
                          {course.status}
                        </div>
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-1328">
                        {course.creditType}
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-1329">
                        {course.created}
                      </td>
                      <td className="px-4 py-3" data-id="element-1330">
                        <div className="flex items-center gap-2 text-sm" data-id="element-1331">
                          <button className="text-blue-600 hover:underline" onClick={() => navigate(`/profile/course-status/edit/${index}`)} data-id="element-1332">
                            Edit
                          </button>
                          <span className="text-slate-300" data-id="element-1333">|</span>
                          <button className="text-red-600 hover:underline" data-id="element-1334">
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}